<template>
  <div class="bg-FFFFFF">
    <common-slide-calendar
      class="bg-FFFFFF"
      :default-date="new Date(dateToTime(defaultDate, '/'))"
      @getDate="methodGetDate"
      @changeCalendarType="changeCalendarType"
      @onTransitionEnd="onTransitionEnd"
      :with-status="true"
      :status-list="dateExceed ? [] : statusList"
      timeFormat="YYYYMMDD"
    >
      <div
        slot="title"
        class="p-16-0 bb fb fb-cross-center fb-main-between c-171A1D font-28 p-0-16"
      >
        <span>{{ computedTimeStr }}</span>
        <div @click="handlerMonth" v-if="changable"
          ><span class="iconfont font-32 mr-5">&#xe682;</span
          ><span>月统计</span></div
        >
      </div>
    </common-slide-calendar>
    <template v-if="!dateExceed">
      <div class="p-20-0 p-0-16 bg-FFFFFF">
        <p
          class="font-26 c-171A1D-56 pt-7"
          v-for="(item, index) in list"
          :key="`time${index}`"
        >
          {{
            `${
              list && list.length > 1 ? '第' + INDEX[index] + '次' : ''
            }上下学：${item.schoolTime.split(' ')[1]}-${
              item.homeTime.split(' ')[1]
            }；${
              (item.homeTimeEnd &&
                '最晚下学：' + item.homeTimeEnd.split(' ')[1]) ||
              ''
            }`
          }}
        </p>
      </div>
      <div
        class="bg-F9F9F9 p-12-0 pl-12 pr-20 m-0-16 font-28 bd-radio-4"
        v-if="askForLeave.length"
      >
        <div
          class="fb fb-main-between fb-cross-center"
          :class="{ bt: index > 0 }"
          v-for="(item, index) in askForLeave"
          @click="handlerRouter(item)"
          :key="index"
        >
          <div class="fb fb-cross-baseline font-34">
            <span class="iconfont c-FF9F00 mr-7">&#xe688;</span>
            <div>
              <div class="fb fb-cross-center">
                <span class="c-171A1D ff-medium lh-24 mb-4"
                  >{{ item.leaveTypeName }}
                </span>
                <span class="ml-4 c-171A1D-60"
                  >({{ methodTransfromTime(item)[1] }})</span
                >
              </div>
              <p class="font-26 c-171A1D-56">{{
                methodTransfromTime(item)[0]
              }}</p>
            </div>
          </div>
          <span class="iconfont font-28 c-171A1D-40">&#xe66b;</span>
        </div>
      </div>
      <div class="addTop" v-show="computedIsCheckInRecked"></div>
      <div
        class="pl-16 pr-6 bg-FFFFFF"
        v-for="(item, index) in list"
        v-show="computedIsCheckInRecked"
        :key="index"
      >
        <common-step
          :show-line="
            !(
              ix === item.checkInRecords.length - 1 && index === list.length - 1
            )
          "
          :icon="1"
          class=""
          v-show="computedIsCheckInRecked"
          v-for="(it, ix) in item.checkInRecords"
          :key="ix"
        >
          <div slot="title">
            <span
              v-if="!it.schoolSign && it.checkInState !== -1"
              class="font-34 lh-18 ff-medium"
              >上学&nbsp;{{ it.checkInTime }}</span
            >
            <span
              v-else-if="it.schoolSign === 1 && it.checkInState !== -1"
              class="font-34 lh-18 ff-medium"
            >
              下学&nbsp;{{ it.checkInTime }}</span
            >
            <span
              v-else-if="it.checkInState === -1 || it.checkInState === 6"
              class="c-171A1D-56 font-26 mb-12"
            >
              打卡&nbsp;{{ it.checkInTime }}</span
            >
          </div>
          <div slot="main" class="pl-10 pb-50">
            <p
              class="c-171A1D-56 font-26 fb fb-cross-center mt-12 pl-12"
              v-if="it.checkInState === -1"
            >
              <i class="iconfont font-32 c-171A1D-56 mr-5">&#xe680;</i
              >打卡无效，{{
                getTimeFlag(it.checkInTime, item.homeTime.split(' ')[1])
              }}时间以最早打卡时间为准
            </p>
            <div class="fb fb-cross-start fb-col">
              <p
                v-if="
                  ~[-1, 1, 2, 3, 4, 6].indexOf(it.checkInState) && it.deviceName
                "
                class="fb fb-cross-center mt-12 p-0-12"
              >
                <i class="iconfont font-32 c-171A1D-56 mr-5">&#xe689;</i>
                <span class="c-171A1D-56 font-26">{{ it.deviceName }}</span>
              </p>
              <div
                class="fb fb-main-between fb-row fb-cross-center mt-12 pl-12 width-full"
                v-if="it.checkInState !== -1 || it.childTemperature"
              >
                <div>
                  <span
                    class="font-24 bd-radio-9999 p-0-10 p-4-0 tag-abnormal"
                    v-if="it.checkInState === 6"
                    >请假</span
                  >
                  <span
                    class="font-24 bd-radio-9999 p-0-10 p-4-0 tag-abnormal"
                    v-if="it.checkInState === 7 || it.checkInState === 8"
                    >未打卡</span
                  >
                  <!-- 旧的记录没有温度 显示正常 有温度就不显示正常 -->
                  <span
                    class="font-24 bd-radio-9999 p-0-10 p-4-0 tag-normal"
                    v-if="
                      (it.checkInState === 1 || it.checkInState === 2) &&
                      !it.childTemperature
                    "
                    >正常</span
                  >
                  <span
                    class="font-24 bd-radio-9999 p-0-10 p-4-0 tag-abnormal"
                    v-if="it.checkInState === 3"
                    >迟到 {{ filterTime(it.timeDiffer) }}</span
                  >
                  <span
                    class="font-24 bd-radio-9999 p-0-10 p-4-0 tag-abnormal"
                    v-if="it.checkInState === 4"
                    >早退 {{ filterTime(it.timeDiffer) }}分钟</span
                  >
                  <span
                    class="font-24 bd-radio-9999 p-0-10 p-4-0 tag-abnormal"
                    v-if="it.checkInState === 12"
                    >上学不用打卡</span
                  >
                  <span
                    class="font-24 bd-radio-9999 p-0-10 p-4-0 tag-abnormal"
                    v-if="it.checkInState === 11"
                    >下学不用打卡</span
                  >
                  <span
                    v-if="it.childTemperature"
                    class="font-26"
                    :class="[
                      +it.childTemperature <= +it.temperatureThresholdMax
                        ? 'c-111F2C-60'
                        : 'c-FB602D',
                      it.checkInState === 1 || it.checkInState === 2
                        ? ''
                        : 'ml-8'
                    ]"
                    >{{ it.childTemperature }}℃</span
                  >
                </div>
                <span
                  class="c-006AFE bd-radio-9999 modifyEnd font-24"
                  v-if="
                    (it.checkInState === 3 ||
                      it.checkInState === 4 ||
                      it.checkInState === 7 ||
                      it.checkInState === 8) &&
                    !it.modifyAttendanceDto &&
                    (curIsAdmin || (modifyFlag && curIsCampusHeadmaster))
                  "
                  @click="
                    methodModifyAttendanceStatus(
                      it,
                      it.checkInState,
                      item.schoolTime,
                      item.homeTime,
                      item.schoolTimeEnd
                    )
                  "
                  >修改结果</span
                >
              </div>
              <p
                v-if="it.modifyAttendanceDto"
                class="mt-12 c-171A1D-56 font-26 p-0-12"
              >
                {{ methodTransfromRemarks(it.modifyAttendanceDto) }}
              </p>
              <div
                class="p-8-0 p-0-12 font-24 bg-F9F9F9 bd-radio-4 mt-6 c-171A1D-56"
                v-if="it.modifyAttendanceDto && it.modifyAttendanceDto.text"
              >
                备注：{{ it.modifyAttendanceDto.text }}
              </div>
              <div class="mt-12 p-0-12">
                <img
                  class="inline-block w-48 h-48"
                  width="48"
                  height="48"
                  v-show="it.catchImageUrl"
                  :src="it.catchImageUrl"
                  alt=""
                  @click="methodEnlargeImg(it.catchImageUrl)"
                />
              </div>
            </div>
          </div>
        </common-step>
      </div>
      <div class="addBottom"></div>
    </template>
    <div
      class="noData fb fb-main-center fb-cross-center text-center bg-FFFFFF"
      v-if="dateExceed"
    >
      <div class="fb fb-col c-171A1D-40">
        <span class="iconfont font-140 c-171A1D-12">&#xe68b;</span>
        <p class="font-26 mt-16 text-center mt-16">超出可查看的统计日期范围</p>
      </div>
    </div>
    <template v-else>
      <div class="noData fb fb-col" v-show="!computedIsCheckInRecked && status">
        <i class="iconfont font-140 c-171A1D-12">&#xe68b;</i>
        <p class="font-26 c-171A1D-40">当天暂无打卡记录</p>
      </div>
      <div class="haveARest fb fb-col" v-show="!status">
        <i class="iconfont font-140 c-171A1D-12">&#xe68c;</i>
        <p class="font-26 c-171A1D-40">当天为休息日</p>
      </div>
    </template>

    <commonImgEnlarge
      :img="enlargeImgUrl"
      v-model="enlargeImgUrl"
    ></commonImgEnlarge>
  </div>
</template>
<script>
import commonSlideCalendar from './commonSlideCalendar'
import commonStep from './commonStep'
import mixin from '../mixin'
import { mcSetTitle, mcToast } from '@/utils/mcSdkUtils'
import commonImgEnlarge from './commonImgEnlarge'
import { unitDayTime, timeFormat, dateToTime, debounce } from '@/utils/comUtils'
import API from '../api'
export default {
  mixins: [mixin],
  props: {
    student: {
      // 学生信息
      type: Object,
      default: () => {
        return {}
      }
    },
    changable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    commonSlideCalendar,
    commonImgEnlarge,
    commonStep
  },
  computed: {
    // 是否有打卡记录有两种：1.没有打卡 2.到了打卡日期但是没有打卡，可以显示日期
    computedIsCheckInRecked() {
      let isCheckInRecked = true
      if (!this.list.length) {
        isCheckInRecked = false
      } else if (
        this.list.length === 1 &&
        !this.list[0].checkInRecords.length
      ) {
        isCheckInRecked = false
      } else {
        let isEmpty = this.list.every(stamp => {
          return !stamp.checkInRecords.length
        })
        if (isEmpty) {
          isCheckInRecked = false
        }
      }
      return isCheckInRecked
    },
    computedTimeStr() {
      return timeFormat(this.startDate, 'YYYY年MM月')
    }
  },
  watch: {},
  data() {
    return {
      dateToTime: dateToTime,
      INDEX: ['一', '二', '三'],
      time: '',
      goSchoolTime: '',
      enlargeImgUrl: '',
      noData: require('../assets/images/noData.png'),
      haveARest: require('../assets/images/haveARest.png'),
      cardRobit: require('../assets/images/cardRobit.png'),
      normal: require('../assets/images/normal.png'),
      list: [],
      askForLeave: [],
      status: null,
      allStatus: [
        '正常上学',
        '正常下学',
        '迟到',
        '早退',
        '缺勤',
        '',
        '下学未打卡',
        '上学未打卡'
      ],
      statusList: [],
      selectedDate:
        this.$store.getters.calendarTime ||
        this.$route.query.dimDate ||
        timeFormat(new Date(), 'YYYYMMDD'),
      calendarType: 0,
      defaultDate: (() => {
        let calendarTime =
          this.$store.getters.calendarTime ||
          this.$route.query.dimDate ||
          timeFormat(new Date(), 'YYYYMMDD')
        let _day =
          +calendarTime.substring(4, 6) === new Date().getMonth() + 1
            ? `0${new Date().getDate()}`.slice(-2)
            : '01'
        let _date =
          calendarTime.length === 6 ? `${calendarTime}${_day}` : calendarTime
        return _date
      })(),
      startDate: new Date(),
      dateExceed: false,
      modifyFlag: true
    }
  },
  methods: {
    // 页面跳转
    handlerRouter(item) {
      this.$router.push({
        path: '/leave/detail',

        query: {
          leaveId: item.leaveId
        }
      })
    },
    async getAllowModifyAttendanceResult() {
      try {
        const res = await API.getAllowModifyAttendanceResult({
          ...this.commonParams
        })
        if (res && res.result && res.result !== '0') {
          mcToast({ msg: res.message || '网络开小差了' })
          return
        }
        this.modifyFlag = res || false
      } catch (error) {}
    },
    // 获取上下学标签
    getTimeFlag(now, time) {
      now = now.replace(':', '')
      time = time.replace(':', '')
      return +now < +time ? '上学' : '下学'
    },
    // 跳转月统计
    handlerMonth() {
      // 没有学生ID 不允许切换
      if (this.student.tpId) {
        this.$store.commit('isCalendarForm', true)
        if (this.$store.getters.isCalendarForm) {
          mcSetTitle('个人月统计')
        } else {
          mcSetTitle('考勤记录')
        }
      }
    },
    // 是否滑动
    onTransitionEnd({ date, calendarType, exceed }) {
      this.calendarType = calendarType
      this.startDate = new Date(date.slice(0, 4), +date.slice(4, 6) - 1, 1)
      this.dateExceed = exceed
      if (exceed) {
        return
      }
      if (date.slice(0, 6) !== this.selectedDate.slice(0, 6)) {
        this.selectedDate = date
      }
      debounce(this.getAttendanceCalendar)()
    },
    // 切换周/月历
    changeCalendarType({ date, calendarType, startDate, exceed } = {}) {
      this.selectedDate = date
      this.startDate = new Date(
        startDate.slice(0, 4),
        +startDate.slice(4, 6) - 1,
        1
      )
      this.dateExceed = exceed
      this.calendarType = calendarType
      let _yearMonth = (date + '').slice(0, -2)
      let year = new Date().getFullYear()
      let month = `0${new Date().getMonth() + 1}`.slice(-2)
      debounce(this.getAttendanceCalendar)()
      if (
        !(
          +_yearMonth < +`${year - 1}${month}` ||
          +_yearMonth > +`${year}${month}`
        )
      ) {
        this.$store.commit('calendarTime', date)
      }
    },
    getAttendanceCalendar(date, type) {
      let _yearMonth = (this.selectedDate + '').slice(0, -2)
      let year = new Date().getFullYear()
      let month = `0${new Date().getMonth() + 1}`.slice(-2)
      if (
        +_yearMonth < +`${year - 1}${month}` ||
        +_yearMonth > +`${year}${month}`
      ) {
        return false
      }
      const { tpId, campusId = this.campusId, tpClassId } = this.student
      let dimDate = date || this.selectedDate
      let dateType = type || this.calendarType
      if (!dateType) {
        let startDate = new Date(dateToTime(dimDate, '/'))
        startDate.setDate(
          startDate.getDate() -
            (startDate.getDay() === 1 ? 0 : startDate.getDay() - 1)
        )
        API.getAttendanceWeekCalendar({
          campusId,
          dingDeptId: tpClassId,
          dingUserId: tpId,
          startDimDay: timeFormat(startDate, 'YYYYMMDD')
        })
          .then(res => {
            this.statusList = res || []
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      } else {
        API.attendanceStatusCalendar({
          dingUserId: tpId,
          month: dimDate.substring(0, 6)
        })
          .then(res => {
            this.statusList = res || []
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 转化备注状态
    methodTransfromRemarks(statusInfo) {
      let _result = `${statusInfo.operatorUserName}在${this.methodTransfromHour(
        statusInfo.modifyTime
      )}将${this.allStatus[statusInfo.oldState - 1]}改为${
        this.allStatus[statusInfo.newState - 1]
      }`
      return _result
    },
    // 时间戳转化为日期
    methodTransfromHour(time) {
      let date = new Date(time)
      let _result = timeFormat(date, 'YYYY年MM月DD日hh:mm')
      return _result
    },
    // 时间格式化
    methodTransfromTime(time) {
      let _time = []
      if (+time.leaveDurationUnit === 2) {
        let _start = new Date(time.start.replace(/-/gi, '/'))
        let _end = new Date(time.end.replace(/-/gi, '/'))
        let _unitDayTime = unitDayTime(+_start, +_end)
        let _seg = ((_end - _start) / (24 * 60 * 60 * 1000)).toFixed(1)
        _time[0] = `${_unitDayTime[0]}～${_unitDayTime[1]}`
        _time[1] = `${_seg}天`
      } else {
        let _start = time.start.replace(/-/g, '.')
        let _end = time.end.replace(/-/g, '.')
        if (time.period > 60) {
          const _HOURS = (time.period / 60).toFixed(1)
          _time[0] = `${_start}～${_end}`
          _time[1] = `${_HOURS}小时`
        } else {
          _time[0] = `${_start}～${_end}`
          _time[1] = `${time.period}分钟`
        }
      }

      return _time
    },
    // 判断是否有打卡记录，以便显示是否需要显示打卡机
    methodGetDate(date) {
      this.selectedDate = date
      this.time = date
      this.$emit('change', date)
    },
    methodEnlargeImg(url) {
      this.enlargeImgUrl = url
    },
    // 日期补0
    methodAddZero(time) {
      if (time < 10) {
        return `0${time}`
      }
      return time
    },
    // 时间计算
    filterTime(time) {
      return time < 60 ? `${time}分钟` : `${~~(time / 60)}小时${time % 60}分钟`
    },
    // 先不需要这个功能
    methodModifyAttendanceStatus(
      detail,
      checkInState,
      schoolTime,
      homeTime,
      schoolTimeEnd
    ) {
      this.$router.push({
        path: '/attendance/detail/modify',
        query: {
          student: JSON.stringify(this.student),
          time: this.time || this.defaultDate,
          checkInState: checkInState,
          detail: JSON.stringify(detail),
          schoolTime,
          homeTime,
          schoolTimeEnd
        }
      })
    },
    init() {
      if (this.student && Object.keys(this.student).length) {
        let emitDate = ''
        if (this.student.date) {
          emitDate = this.student.date
        } else {
          let newTime = new Date()
          let year = newTime.getFullYear()
          let month = this.methodAddZero(newTime.getMonth() + 1)
          let day = this.methodAddZero(newTime.getDate())
          emitDate = this.$store.getters.calendarTime || `${year}${month}${day}`
          this.student.date = emitDate
        }
        this.methodGetDate(emitDate)

        this.$store.commit('calendarTime', emitDate)
        debounce(this.getAttendanceCalendar)()
        debounce(this.getUserAttenceReport)()
      }
    },
    getUserAttenceReport() {
      let _yearMonth = (this.selectedDate + '').slice(0, -2)
      let year = new Date().getFullYear()
      let month = `0${new Date().getMonth() + 1}`.slice(-2)
      if (
        +_yearMonth < +`${year - 1}${month}` ||
        +_yearMonth > +`${year}${month}`
      ) {
        return false
      }
      const { tpId, timestamp = '', campusId = this.campusId } = this.student
      API.attendanceDayRecord({
        operUserRoleType: this.currentRole,
        campusId,
        date: this.selectedDate,
        dingUserId: tpId,
        timestamp
      })
        .then(res => {
          this.status = res.status
          this.askForLeave = res.leaves
          this.list = res.userDailyRecords
          if (!tpId) {
            this.$emit('initStudent', res.studentDingId)
          }
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    }
  },
  mounted() {
    if (this.$store.getters.isCalendarForm) {
      mcSetTitle('个人月统计')
    } else {
      mcSetTitle('考勤记录')
    }
    this.$watch('selectedDate', {
      immediate: true,
      handler() {
        debounce(this.getUserAttenceReport)()
      }
    })
    this.$watch('student', {
      handler(v) {
        if (v && v.tpId) {
          this.init()
        }
      },
      deep: true
    })
    this.student.tpId && debounce(this.getAttendanceCalendar)()
    this.getAllowModifyAttendanceResult()
  }
}
</script>
<style lang="scss" scoped>
.noData,
.haveARest {
  height: 360px;
  text-align: center;
  img {
    margin: 0 auto;
    margin-top: 45px;
    height: 60px;
    width: 60px;
  }
  p {
    margin-top: 16px;
    text-align: center;
    color: rgba(25, 31, 37, 0.4);
  }
}
.tag-abnormal {
  background: #fdf2de;
  color: #ff9f00;
}
.tag-normal {
  background: #def5e9;
  color: #00b853;
}

.addBottom {
  height: 40px;
}

.addTop {
  height: 14px;
  background-color: #ffffff;
}

.modifyEnd {
  display: inline-block;
  padding: 3px 8px;
  border: 1px solid;
}
.lh-1 {
  line-height: 20px;
}
</style>
